import { Pipe, PipeTransform } from '@angular/core';

@Pipe( { name: 'round' } )
export class RoundPipe implements PipeTransform {

    transform( pNumber: number ): number {
        return Math.round(pNumber);
    }
}